import styled from 'styled-components';

export const CheckBoxLabel = styled.label(props => `
  display: block;
  position: relative;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: ${props?.alignItems || 'center'};
  &:hover {
    ${!props.showLoader && `
      ${Checkmark}, ${CheckboxText} {
        border-color: #2276e3;
        color: #2276e3;
      }
    `}
  }
`)

export const Checkmark = styled.span(
  props => `
  position: relative;
  height: 18px;
  width: 18px;
  background: white;
  border: solid 2px #647a97;
  border-radius:2px;
  margin-top: ${props?.marginTop || '0'};
  &::after {
    display: none;
    content: '';
    left: 6px;
    top: 2px;
    position: absolute;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
  }
  &:hover {
    color: blue;
  }
`)

export const CheckBoxContainer = styled.div`
  display: flex;
`

export const CheckBox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  &:checked ~ ${Checkmark} {
    background:#2276e3;
    border: none;
    &::after {
      display: block;
    }
  }
  &:hover {
    color: blue;
  }
`

export const CheckboxIcon = styled.span(
  props => `
    display: flex;
    background-color:#f3f6f8;
    border-radius:0.3rem;
    padding:${props.theme.spacing.small};
    margin-left:${props.theme.spacing.base};
    min-width: 2.5rem;
    height: 2.5rem;
  `
);

export const TitleSubtitleCont = styled.div(props =>`
  width: 100%;
  ${props.showLoader && `
    opacity: 0.48;
  `}
`);

export const CheckboxText = styled.span(
  props => `
    padding-left: 1rem;
    font-size:1.4rem;
    max-width: 30rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: ${props?.fontWeight || '400'};
  `
);

export const CheckboxSubtitle = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  color: #757575;
  font-weight: 400;
  padding-top: 4px;
  padding-left: 1rem;
`;

export const CheckboxSuffix = styled.div(props =>`
  font-weight: 500;
  font-size: 16px;
  position: absolute;
  right: 16px;
  transform: translateY(-50%);
  color: black;
  top:8px;
  ${props.showLoader && `
    opacity: 0.48;
  `}
`);

export const HorizontalLine = styled.hr`
  border: none;
  border-top: 1px solid #e4e4e4;
  margin: 0;
`;

export const InfoText = styled.div`
  font-size: 12px;
  color: #714d0a;
  padding-left: 1rem;
  padding-top: 8px;
`

export const OptionContainer = styled.div`
  padding-left: 1rem;
  padding-top: 8px;  
  display: flex;
`

export const OptionsCont = styled.div` 
  display: flex;
  align-items: center;
`

export const Option = styled.span`
  font-size: 14px;
  color: #757575;
  padding-right: 16px;
  padding-left: 4px;
`

export const Loader = styled.div`
  position: relative;
  width: 18px;
  height: 18px;
  border: 2px solid #2276e3;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
